var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "jcb 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1953 13.2528C9.57031 13.2528 7.54688 14.9481 7.54688 17.9012V26.3231C7.76562 27.3622 8.85937 28.1278 10.0625 28.1278C11.4297 28.1278 12.4141 27.1434 12.4141 25.9403V21.6747H16.1328V25.8856C16.1328 28.2372 13.125 29.4403 10.9375 29.4403C9.67969 29.4403 8.47656 29.0575 7.60156 28.4012V37.6981H13.5078C15.5859 37.6981 17.9922 35.7294 17.9922 33.2137V13.2528H12.1953Z",
    fill: "#1174CE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.54688 17.9012V26.3231C7.76562 27.3622 8.85937 28.1278 10.0625 28.1278C11.4297 28.1278 12.4141 27.1434 12.4141 25.9403V21.6747H16.1328V25.8856C16.1328 28.2372 13.125 29.4403 10.9375 29.4403C9.67969 29.4403 8.47656 29.0575 7.60156 28.4012V37.6981H13.5078C15.5859 37.6981 17.9922 35.7294 17.9922 33.2137V13.2528",
    fill: "#0F549D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.0781 21.6747V25.8856C16.0781 28.2372 13.0703 29.4403 10.8828 29.4403C9.625 29.4403 8.42188 29.0575 7.54688 28.4012V37.6981H13.4531C15.5312 37.6981 17.9375 35.7294 17.9375 33.2137",
    fill: "#02375E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.8672 28.0184H35.4375C36.0938 28.0184 36.6953 27.4169 36.6953 26.7606C36.6953 26.1044 36.0938 25.5028 35.4375 25.5028H32.8672V28.0184Z",
    fill: "#146643"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M35.7656 13.2528C33.0859 13.2528 31.1172 14.9481 31.1172 17.8466V21.6747H38.0078C38.9922 21.6747 39.8125 22.495 39.8125 23.4794C39.8125 24.4637 38.9922 25.2841 38.0078 25.2841C39.1016 25.2841 39.9766 26.0497 39.9766 27.0341C39.9766 28.0184 39.1562 28.7841 38.0078 28.7841H31.0625V37.6981H36.9687C39.0469 37.6981 41.4531 35.7294 41.4531 33.2137V13.2528H35.7656Z",
    fill: "#1BCC38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M31.0625 17.9012V21.6747H37.9531C38.9375 21.6747 39.7578 22.495 39.7578 23.4794C39.7578 24.4637 38.9375 25.2841 37.9531 25.2841C39.0469 25.2841 39.9219 26.0497 39.9219 27.0341C39.9219 28.0184 39.1016 28.7841 37.9531 28.7841H31.0625V37.6981H36.9687C39.0469 37.6981 41.4531 35.7294 41.4531 33.2137V13.2528",
    fill: "#329947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M39.7578 23.4794C39.7578 24.4637 38.9375 25.2841 37.9531 25.2841C39.0469 25.2841 39.9219 26.0497 39.9219 27.0341C39.9219 28.0184 39.1016 28.7841 37.9531 28.7841H31.0625V37.6981H36.9687C39.0469 37.6981 41.4531 35.7294 41.4531 33.2137M36.6406 23.6981C36.6406 23.0419 36.0391 22.4403 35.3828 22.4403H32.8672V24.9012H35.4375C36.0938 24.9012 36.6406 24.3544 36.6406 23.6981Z",
    fill: "#146643"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M23.8984 13.2528C21.2188 13.2528 19.25 14.9481 19.25 17.8466V22.5497C19.9062 22.0028 20.7266 21.62 21.6016 21.62H27.8359V22.9325C26.3594 22.6044 24.9375 22.4403 24.2266 22.4403C22.6953 22.4403 21.4375 23.6981 21.4375 25.2294C21.4375 26.7606 22.6953 28.0184 24.2266 28.0184C24.9375 28.0184 26.3594 27.9091 27.8359 27.5809V28.7841H21.6016C20.7266 28.7841 19.8516 28.4559 19.25 27.8544V37.6981H25.1563C27.2344 37.6981 29.6406 35.7294 29.6406 33.2137V13.2528H23.8984Z",
    fill: "#E20E37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M19.25 17.9012V22.6044C19.9062 22.0575 20.7266 21.6747 21.6016 21.6747H27.8359V22.9872C26.3594 22.6591 24.9375 22.495 24.2266 22.495C22.6953 22.495 21.4375 23.7528 21.4375 25.2841C21.4375 26.8153 22.6953 28.0731 24.2266 28.0731C24.9375 28.0731 26.3594 27.9637 27.8359 27.6356V28.7841H21.6016C20.7266 28.7841 19.8516 28.4559 19.25 27.8544V37.6981H25.1563C27.2344 37.6981 29.6406 35.7294 29.6406 33.2137V13.2528",
    fill: "#B41F36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M27.8359 21.6747V22.9872C26.3594 22.6591 24.9375 22.495 24.2266 22.495C22.6953 22.495 21.4375 23.7528 21.4375 25.2841C21.4375 26.8153 22.6953 28.0731 24.2266 28.0731C24.9375 28.0731 26.3594 27.9637 27.8359 27.6356V28.7841H21.6016C20.7266 28.7841 19.8516 28.4559 19.25 27.8544V37.6981H25.1563C27.2344 37.6981 29.6406 35.7294 29.6406 33.2137",
    fill: "#720A1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.0c6951a0eb79e7d27dc5a86e332f85bc.svg";
export { ForwardRef as ReactComponent };